module.exports = __webpack_public_path__ + "media/icons/wrench-34c3c162.svg";